import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import data from './data';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: '6px 16px'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}));

export default function BasicTimeline() {
  const classes = useStyles();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const renderTimeLineData = () => {
    return data.map((item, idx) => {
      return <TimeLineItemData key={idx} data={item} />;
    });
  };

  const TimeLineContentData = props => {
    const { data } = props;
    return (
      <TimelineContent>
        <Paper elevation={1} className={classes.paper}>
          {data.map((item, idx) => (
            <Typography key={idx}>{item.text}</Typography>
          ))}
        </Paper>
      </TimelineContent>
    );
  };

  const TimeLineItemData = props => {
    const { items, meta } = props.data;
    return (
      <TimelineItem>
        <TimelineOppositeContent>
          <Typography color='textSecondary'>{meta.year}</Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color='secondary' />
          <TimelineConnector />
        </TimelineSeparator>
        <TimeLineContentData data={items} />
      </TimelineItem>
    );
  };
  return <Timeline align='alternate'>{renderTimeLineData()}</Timeline>;
}
